import 'styled-components';

import light from './light';

const dark: typeof light = {
  ...light,
  colors: {
    ...light.colors,

    PROGRESS_BG: 'rgba(0,0,0,0.2)',
    PROGRESS_OVERLAY_BG: 'rgba(0,0,0,0.1)',

    AREA_BG: '#333',

    MENU_BG: '#333',
    MENU_TEXT: '#333',
    MENU_LINK_BG: 'rgba(0,0,0,0.1)',
    MENU_LINK_BG_HOVER: '#2bc48a',
    MENU_LINK_TEXT: '#333',
    MENU_LINK_TEXT_HOVER: '#FFF',
    MENU_IC: '#2bc48a',
    MENU_VERSION: '#666',

    HEADER_BG: '#333',
    HEADER_TEXT: '#FFF',
    HEADER_IC: '#fff',
    HEADER_SEARCH_COLOR: '#333',
    HEADER_BUTTON_BG: '#2bc48a',
    HEADER_BUTTON_TEXT: '#FFF',
    HEADER_BUTTON_BG_HOVER: '#333',
    HEADER_BUTTON_TEXT_HOVER: '#fff',
    HEADER_PLUS: '#f15825',

    BUTTON_BG: '#2bc48a',
    BUTTON_TEXT: '#FFF',
    BUTTON_BG_HOVER: '#333',
    BUTTON_TEXT_HOVER: '#fff',

    SESSION_TITLE: '#333',
    SESSION_SUBTITLE: '#666',
    SESSION_BACK_BG: '#2bc48a',
    SESSION_BACK_BG_HOVER: '#333',
    SESSION_BACK_TEXT: '#FFF',

    GRID_BG: 'rgba(0,0,0,0.1)',
    GRID_HEAD_ITEM_BG: 'rgba(0, 0, 0, 0.01)',
    GRID_HEAD_ITEM_TEXT: '#333',
    GRID_ITEM_TEXT: '#333',
    GRID_ITEM_TEXT_BOLD: '#333',
    GRID_MENU_IC: '#333',

    GRADIEN_COLOR_1: '#d4e1d4',
    GRADIENT_COLOR_2: '#edffef',
    GRADIENT_CIRCLE: 'rgb(21 116 25 / 10%)',

    COLLAPSE_COLOR1: '#FFF',
    COLLAPSE_COLOR2: '#eee',
    COLLAPSE_IC: '#333',

    FORM_LABEL_IC_BG_ENABLE: '#2bc48a',
    FORM_LABEL_IC_BG: 'rgba(0, 0, 0, 0.2)',
    FORM_LABEL_IC: '#333',
    FORM_LABEL_IC_ENABLE: '#333',
    FORM_LABEL_TITLE: '#333',
    FORM_LABEL_SUBTITLE: '#666',

    FORM_INPUT_TEXT: '#333',
    FORM_INPUT_BG: 'rgba(0,0,0,0.01)',
    FORM_INPUT_PLACEHOLDER: 'rgba(0,0,0,0.2)',

    FORM_CANCEL_TEXT: '#666',

    FORM_SORTABLE_ITEM_TEXT: '#333',

    PROGRESSBAR_BG_1: '#c3f9cc85',
    PROGRESSBAR_BG_2: '#a3d1c095',
    PROGRESSBAR_BAR_BG_1: '#ccc',
    PROGRESSBAR_BAR_BG_2: '#fff',
    PROGRESSBAR_PERCENT_BG: '#2bc48a',
    PROGRESSBAR_BG_MOBILE: '#FFF',

    DIALOG_BG_MOBILE: '#2bc48a76',
    DIALOG_BG_1: '#c3f9cc85',
    DIALOG_BG_2: '#a3d1c095',
    DIALOG_WAVE: '#2bc48a21',

    DROP_IC: '#333',
    DROP_BORDER: 'rgba(0,0,0,0.1)',
    DROP_TEXT: '#333',
  },
};

export default dark;
